<template>
  <span :class="`bundle bundle-${color}`">
    {{ $t(`phone-number.number.is_spam.${value ? 'yes' : 'no'}`) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Boolean, Number],
        default: false
      }
    },

    computed: {
      color: function() {
        return this.value ? 'error' : 'green';
      }
    }
  };
</script>
